
export default [
    {
        path: '/assessment/',
        name: 'GenericAssessmentView',
        component: () =>
            import ("@/components/assessment/GenericAssessmentView"),
    },
];